import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div
        data-testid="auth-loading"
        className="flex min-h-screen items-center justify-center text-slate-500"
      >
        <span className="label-overline">Loading session…</span>
      </div>
    );
  }

  if (!user) {
    const redirect = role === "admin" ? "/admin/login" : "/portal";
    return <Navigate to={redirect} replace state={redirectState} />;
  }

  if (role && user.role !== role) {
    const redirect = user.role === "admin" ? "/admin" : "/dashboard";
    return <Navigate to={redirect} replace />;
  }

  return children;
}
